export default __webpack_public_path__ + "static/media/049-frame.ad3283e1.svg";